import tippy from 'tippy.js';
import { layer } from '~/assets/icons/js/layer';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('form');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults: {
            ...MODEL.prototype.defaults,
            tagName: 'form',
            attributes: {
                "data-slg-type": "C-FORM-SWIPER"
            },
            style: {
                "min-width": '100px',
                "min-height": '100px'
            },
            classes: ['swiper'],
            components: [
                {
                    type: 'C-FORM-SWIPER-WRAPPER',
                    components: [
                        {
                            type: "C-FORM-SWIPER-SLIDE",
                        },
                        {
                            type: "C-FORM-SWIPER-SLIDE"
                        }
                    ]
                },
            ]
        }
    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute('data-slg-type') == "C-FORM-SWIPER")
                return { type: 'C-FORM-SWIPER' }
        }
    });

    var view = VIEW.extend({
        init: function () {
            // let component = this.model;
            // this.swiper = new Swiper(this.el, {
            //     autoHeight: true,
            //     spaceBetween: 20,
            //     allowTouchMove: false,
            // });
        }
    });

    DOMC.addType('C-FORM-SWIPER', {
        model: model,
        view: view,
    });

    BM.add('B-FORM-SWIPER', {
        label: "FORM SWIPER",
        content: {
            type: 'C-FORM-SWIPER',
        },
        media: layer,
        category: "ADVANCE COMPONENT",
    });
};
